// Login-activation lookup for the User/Caseworker tab: which login accounts have
// actually been signed into at least once (so the list can show a "Live" badge).
// last_sign_in_at lives on auth.users, readable only with the service role, so this
// goes through the admin-users Edge Function (login_activation action, admin-only,
// read-only). Returns {} on any error so the UI simply shows no badge.

import { logger } from "../utils/logger";
import { getSupabaseClient } from "../utils/supabase";

const EDGE_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/admin-users`;

export async function fetchLoginActivation(
  userIds: string[]
): Promise<Record<string, string | null>> {
  const ids = Array.from(new Set((userIds || []).filter((x): x is string => !!x)));
  if (ids.length === 0) return {};
  const c = getSupabaseClient();
  if (!c) return {};
  try {
    const sessionRes = await c.auth.getSession();
    const token = sessionRes.data?.session ? sessionRes.data.session.access_token : "";
    const resp = await fetch(EDGE_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ action: "login_activation", user_ids: ids }),
    });
    if (!resp.ok) {
      logger.warn("fetchLoginActivation failed:", resp.status);
      return {};
    }
    const json = await resp.json();
    return json?.activation || {};
  } catch (e) {
    logger.warn("fetchLoginActivation error:", e);
    return {};
  }
}

// Pure: has this user signed in at least once (a truthy last_sign_in_at)?
export function hasLoggedIn(
  activation: Record<string, string | null>,
  userId: string | null | undefined
): boolean {
  return !!userId && !!activation[userId];
}
